import {
  Text,
  Color,
  Glyph,
  FontWeight,
  Box,
  AlignItems,
  TypePreset,
  H3,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { MarketingBenefit } from "./MarketingBenefit";

export const SignUpFormMarketing = () => (
  <Box
    layout="flex"
    flexDirection="column"
    alignItems={AlignItems.Center}
    width="375px"
    height="100%"
    spaceAbove={4}
  >
    <H3
      weight={FontWeight.Bold}
      color={Color.Greystone_50}
      preset={TypePreset.Heading_08}
      spaceAbove={6}
      spaceBelow={3}
      size={8}
    >
      <Trans id="sign-up.form-marketing.heading">
        Get paid on time without the chasing, admin, or stress
      </Trans>
    </H3>

    <MarketingBenefit
      iconGlyph={Glyph.Global}
      benefit={
        <Text color={Color.Greystone_50} size={3}>
          <Trans id="sign-up.form-marketing.benefit-text-one">
            Easily collect one-off and recurring payments in 30+ countries
          </Trans>
        </Text>
      }
    />
    <Box gutterV={1.5} />
    <MarketingBenefit
      iconGlyph={Glyph.DashboardChecked}
      benefit={
        <Text color={Color.Greystone_50} size={3}>
          <Trans id="sign-up.form-marketing.benefit-text-two">
            Use GoCardless with 350+ seamless integrations, our API, or our
            dashboard
          </Trans>
        </Text>
      }
    />
    <Box gutterV={1.5} />
    <MarketingBenefit
      iconGlyph={Glyph.Office}
      benefit={
        <Text color={Color.Greystone_50} size={3}>
          <Trans id="sign-up.form-marketing.benefit-text-three">
            GoCardless is trusted by 75,000+ businesses. Of all sizes.
            Worldwide.
          </Trans>
        </Text>
      }
    />
  </Box>
);
